import { useState } from 'react'

import { solemService } from '../services'


const useSolem = () => {
    const [solemState, setSolemState] = useState<any>({})

    const getSolemNamesByRut = async (rut: string) => {
        const resp = await solemService.getSolemNamesByRut(rut)
        setSolemState(resp.data)
        return resp.data
    }

    return {
        solemState,
        getSolemNamesByRut
    }
}

export { useSolem }